import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ConsultationForm from "./sections/ConsultationForm";
import MarylandOffice from "./sections/MarylandOffice";
import FirmInformation from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <ConsultationForm />
      <MarylandOffice />
      <FirmInformation />
    </div>;
}